<div [class]="layoutOuter">
  <div [class]="layoutSidePanel">
    <div class="absolute inset-0 z-0 bg-linear-to-tr from-navy via-navy/50 to-emerald/30"></div>
    <div class="absolute inset-0 z-0 bg-cover bg-center" [style.backgroundImage]="'url(' + sidePanelBgImage + ')'"></div>
    <div [class]="layoutOverlay"></div>
    <div class="relative z-10">
      <div class="flex items-center gap-3 mb-8">
        <div class="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center border border-white/20">
          <img ngSrc="logo-white.svg" height="24" width="24" alt="BAILIA" class="w-6 h-6"/>
        </div>
        <span class="text-xl font-bold tracking-wide">BAILIA</span>
      </div>
    </div>

    <div class="absolute bottom-12 left-12 right-12 text-white">
      <h2 class="text-4xl font-display font-bold mb-4 leading-tight text-white">
        L'immobilier repensé pour <br />votre sérénité.
      </h2>
      <p class="text-lg text-gray-200 max-w-md font-light">
        Que vous soyez propriétaire ou locataire, BAILIA simplifie chaque étape de votre parcours immobilier.
      </p>
      <div class="flex gap-2 mt-8">
        <div class="h-1 w-8 bg-white rounded-full"></div>
        <div class="h-1 w-2 bg-white/30 rounded-full"></div>
        <div class="h-1 w-2 bg-white/30 rounded-full"></div>
      </div>
    </div>
  </div>


  <div class="flex-1 flex flex-col items-center justify-center p-4 md:p-12 overflow-y-auto">
    <div class="w-full max-w-md space-y-8">
      <z-card class="p-8 shadow-xl border-0 md:shadow-none md:p-0 md:bg-transparent">
        <div class="md:hidden flex justify-center mb-6">
          <div class="w-16 h-16 bg-[#1A2E47] rounded-2xl flex items-center justify-center shadow-md">
            <img ngSrc="/logo-white.svg" alt="BAILIA" height="24" width="24" class="w-10 h-10"/>
          </div>
        </div>

        <div class="mb-10">
          <button (click)="router.navigate(['/welcome'])"
                  class="flex items-center gap-2 text-gray-400 hover:text-navy transition-colors mb-6 group">
            ← Retour
          </button>
          <h1 class="text-3xl font-bold text-navy mb-2">Bon retour parmi nous !</h1>
          <p class="text-gray-500">Accédez à votre espace sécurisé.</p>
        </div>


        <div class="space-y-6">
          @if (errorMessages().length) {
            <div class="rounded-lg border border-destructive/20 bg-destructive/10 px-4 py-3 text-sm text-destructive">
              @for (message of errorMessages(); track message) {
                <p>{{ message }}</p>
              }
            </div>
          }

          <div class="space-y-1.5">
            <label zLabel class="font-medium ml-1" [class.text-destructive]="emailErrors().length > 0"
                   [class.text-gray-700]="emailErrors().length === 0" for="email">Adresse e-mail</label>
            <input zInput type="email" [zStatus]="emailErrors().length > 0 ? 'error' : undefined"
                   class="h-12 rounded-xl bg-gray-50 border-gray-200 focus:bg-white focus:ring-emerald focus:border-emerald transition-all"
                   id="email" placeholder="exemple@email.com" [(ngModel)]="email"/>
            @if (emailErrors().length) {
              <div class="text-sm text-destructive mt-1 font-medium">
                @for (msg of emailErrors(); track msg) {
                  <p class="text-destructive">{{ msg }}</p>
                }
              </div>
            }
          </div>

          <div class="space-y-1.5">
            <div class="flex justify-between items-center ml-1 mb-1">
              <label zLabel class="font-medium ml-1" [class.text-destructive]="passwordErrors().length > 0"
                     [class.text-gray-700]="passwordErrors().length === 0" for="password">Mot de passe</label>
              <button class="text-xs text-emerald font-medium hover:underline">Oublié ?</button>
            </div>
            <div class="relative">
              <input zInput [type]="showPassword() ? 'text' : 'password'"
                     [zStatus]="passwordErrors().length > 0 ? 'error' : undefined"
                     class="h-12 rounded-xl bg-gray-50 border-gray-200 focus:bg-white focus:ring-emerald focus:border-emerald pr-10"
                     id="password"
                     placeholder="Entrez votre mot de passe" [(ngModel)]="password"/>
              <button type="button" class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                      (click)="showPassword.set(!showPassword())">
                <ng-icon [name]="showPassword() ? 'lucideEyeOff' : 'lucideEye'" class="w-4 h-4"/>
              </button>
            </div>
            @if (passwordErrors().length) {
              <div class="text-sm text-destructive mt-1 font-medium">
                @for (msg of passwordErrors(); track msg) {
                  <p class="text-destructive">{{ msg }}</p>
                }
              </div>
            }
          </div>
        </div>

        <button z-button type="button" [zDisabled]="!email() || !password() || isSubmitting()"
                class="w-full bg-emerald hover:bg-emerald/90 text-white h-12 rounded-full text-base font-semibold shadow-lg shadow-emerald/20 disabled:opacity-50 disabled:shadow-none mt-8"
                (click)="handleLoginSubmit()">
          {{ isSubmitting() ? 'Connexion...' : 'Se connecter' }}
        </button>

        <div class="text-center text-sm pt-4">
          <p class="text-center text-sm text-gray-500 pt-2">
            Nouveau sur BAILIA ?
            <button (click)="router.navigate(['/signup'])" class="text-emerald font-semibold hover:underline">Créer un compte</button>
          </p>
        </div>
      </z-card>
    </div>
  </div>
</div>
